globalThis.Icon = class Icon {
  constructor(name) {
    this.div = document.createElement("div");
    this.div.classList.add("icon");
    this.setByName(name);
  }

  setByName(name) {
    const icon = globalThis.ICONS[name];
    if (!icon) return;
    this.setSpritePosition(icon.x, icon.y);
  }

  setSpritePosition(x, y) {
    this.div.style.setProperty("--sprite-x", x);
    this.div.style.setProperty("--sprite-y", y);
  }
};
